import { isNil } from 'lodash';

export function formatPhoneNumberInput(phoneNumberInput: string): string {
  if (!phoneNumberInput) {
    return '';
  }
  const cleansedPhoneNumber = cleansePhoneNumber(phoneNumberInput);
  const p1 = cleansedPhoneNumber.substring(0, 3);
  const p2 = cleansedPhoneNumber.substring(3, 6);
  const p3 = cleansedPhoneNumber.substring(6, 10);

  const fragments = [
    p1.length > 0 ? '(' : '',
    p1,
    p2.length > 0 ? ') ' : '',
    p2,
    p3.length > 0 ? '-' : '',
    p3,
  ];

  return fragments.join('');
}

export function cleansePhoneNumber(phoneNumber: string): string {
  if (!phoneNumber) {
    return '';
  }
  let cleansedPhoneNumber = phoneNumber.replace(/\D/g, '');
  // real phone numbers never have area codes starting with 1, but our fake numbers on staging do
  if (cleansedPhoneNumber[0] === '1' && cleansedPhoneNumber.length > 10) {
    cleansedPhoneNumber = cleansedPhoneNumber.substring(1, 11);
  } else {
    cleansedPhoneNumber = cleansedPhoneNumber.substring(0, 10);
  }
  return cleansedPhoneNumber;
}

export function centsToCurrencyString(valueCents: number, roundToCents: boolean = false) {
  const dollars = valueCents / 100;
  const showNegative = roundToCents ? dollars <= -0.005 : dollars <= -0.5;
  const dollarsString = Math.abs(dollars).toLocaleString('en-US', {
    maximumFractionDigits: roundToCents ? 2 : 0,
  });
  return `${showNegative ? '-' : ''}$${dollarsString}`;
}

export function usdToCurrencyString(valueUsd: number, roundToCents: boolean = false) {
  return centsToCurrencyString(valueUsd * 100, roundToCents);
}

export function fractionToPercentString(
  valueFraction: number,
  maximumFractionDigits: number = 1,
  minimumFractionDigits: number = 0,
) {
  return valueFraction.toLocaleString('en-US', {
    maximumFractionDigits,
    minimumFractionDigits,
    style: 'percent',
  });
}

export function numberToSqFt(value: number) {
  return !isNil(value) ? `${value.toLocaleString()} ft²` : '';
}

export function stringToTitleCase(value: string) {
  if (!value) {
    return '';
  }

  return value
    .split(' ')
    .map(word => {
      return word.length ? word.replace(word[0], word[0].toUpperCase()) : word;
    })
    .join(' ');
}

export function humanizeDocumentType(documentType: string) {
  const formattedDocumentType = documentType.startsWith('rs_')
    ? documentType.slice(3)
    : documentType;
  return stringToTitleCase(formattedDocumentType.replace(/_/g, ' '));
}

export function escapeRegExp(str: string): string {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}
